export default __webpack_public_path__ + "static/media/img_baseCotton_flowers_p.3bfa397a.jpg";